import { useAppLoader } from '@capsicum/common';
import { useCallback } from 'react';

import { type MobileNumberGenerateCodeParams, type WelcomeVariant } from '../models';

import { useSendVerificationCode } from './useSendVerificationCode';

export const useSendCodeBySMS = ({ appHash }: { appHash?: string } = {}) => {
	const loader = useAppLoader();
	const { sendSmsCodeToUser, sendSmsCodeToUserOnRegistration } = useSendVerificationCode({ appHash });

	return useCallback(
		({
			attempt,
			captchaInformation,
			countryCode,
			mobileNumber,
			variant
		}: MobileNumberGenerateCodeParams & { variant: WelcomeVariant }) => {
			return loader(
				(variant === 'register' ? sendSmsCodeToUserOnRegistration : sendSmsCodeToUser)({
					attempt,
					captchaInformation,
					countryCode,
					mobileNumber
				})
			);
		},
		[loader, sendSmsCodeToUser, sendSmsCodeToUserOnRegistration]
	);
};
